
export const PASSWORD_REGEX = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/;

export const PASSWORD_VALIDATION_MESSAGE = 'Password must contain at least 1 uppercase letter, 1 lowercase letter, 1 digit and be at least 6 characters long.';